export type AppNavPane = 'launch' | 'personal' | 'manager' | 'user' | 'settings' | 'employees';

export function appNavPane(input: {
	pathname: string;
	isLaunch: boolean;
	managerMode: boolean;
	viewerId?: string;
}): AppNavPane {
	if (input.isLaunch) {
		return 'launch';
	}

	if (
		input.pathname === '/settings/employees' ||
		input.pathname.startsWith('/settings/employees/')
	) {
		return 'employees';
	}

	if (input.pathname === '/settings' || input.pathname.startsWith('/settings/')) {
		return 'settings';
	}

	const userMatch = input.pathname.match(/^\/users\/([^/]+)/);
	if (userMatch && userMatch[1] !== input.viewerId) {
		return 'user';
	}

	if (input.managerMode) {
		return 'manager';
	}

	return 'personal';
}
